import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import AdSense from 'react-adsense';
import { Helmet } from "react-helmet";
import axios from 'axios';
import { Cookies } from '../../index.js';
import { alert_error, alert_success } from "../../AppContext.js";
import { useParams, useNavigate, Link } from 'react-router-dom';
// import Create_link from './create_link';
// import History_buylink from './history_buylink';
// import History_create from './history_create';
// import History_home from './history';
import Orders_account from './orders/orders';
import Orders_home from './orders/home';
import Nhatkyaccount from '../../nhatkyorders';
import Post_content from '../../community/content/Blog_posts.jsx';
// import Api from './api';
import Sellers from "./sellers/home.jsx";
import Tabs_nav from "../../app_structure/tabs_nav/tabs_home.jsx";
import ProfileNav from "../../order/orders/ProfileNav.jsx";

const Account_home = () => {
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    const { slug_1, slug_2 } = useParams();
    const [userOption, setUserOption] = useState(slug_2);
    useEffect(() => {
        setUserOption(slug_2);
    }, [slug_2]);
    return (
        <>
            {
                slug_1 &&
                (<>
                    {(slug_1 === 'product' && slug_2 === 'home') && (<>      <div className='text-center'>
                        <div className='inline-block  text-center font-medium text-gray-700   mt-1 rounded-xl'>
                            <ProfileNav userOption={userOption} setUserOption={setUserOption} />
                        </div>
                    </div></>)}
                    <Tabs_nav category={'mmo_p2p_shop'} />
                    {slug_1 === 'sellers' && (<> <Sellers /></>)}
                    {slug_1 === 'product' && (<> <Orders_home /></>)}
                </>)
            }
        </>
    );
};

export default Account_home;
